<template >
  <div class="mainbody">
    <div style="padding: 16px 32px 16px 0px">
      <span class="title">商品管理</span>
      <el-button type="primary" size="small" style="float: right" @click="addInfo()">添加商品</el-button>
    </div>
    <div class="aLine"></div>
    <div class="tableInfo">
      <el-table :data="data_list" @filter-change="filterChange" :cell-style="cellStyle">
        <el-table-column prop="order" label="排序" min-width="1"></el-table-column>
        <el-table-column prop="id" label="商品ID" min-width="1"></el-table-column>
        <el-table-column prop="title" label="商品名称" min-width="3"></el-table-column>
        <el-table-column prop="stock" label="库存总数" min-width="1"></el-table-column>
        <el-table-column prop="mobile_stock" label="可用数量" min-width="1"></el-table-column>
        <el-table-column prop="lock_stock" label="锁定数量" min-width="1"></el-table-column>
        <el-table-column prop="sales" label="总销量" min-width="1"></el-table-column>
        <el-table-column prop="pushStr" label="是否推送" min-width="1"></el-table-column>
        <el-table-column prop="resultStr" label="商品状态" min-width="1" :filters="optionsOpen" filter-placement="bottom-end" column-key="filterResult"></el-table-column>
        <el-table-column prop="operating" label="操作" min-width="2" align="left">
          <template slot-scope="scope">
            <el-button class="operateText" size="mini" type="text" @click="editInfo(scope.row)">编辑</el-button>
            <el-button class="operateText" size="mini" type="text" @click="deleteInfo(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :key="elementui_page_key"
        class="elPagination"
        background
        layout="prev, pager, next"
        :page-size="pageMaxSize"
        :page-count="pageCount"
        :current-page="currentPage"
        @current-change="currentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import * as Utils from '@/utils/utils.js'
import * as StrUtils from '@/utils/strUtils.js'
import * as Constant from '@/utils/constant.js'
import * as CApi from '@/api/constant_api.js'
import * as Api from '@/api/api.js'
import { URL_PATH, LIST_PAGE_MAX_SIZE } from '@/config/config'
import leftMeun from '@/components/layout/leftMeun'
import headRight from '@/components/layout/headRight'
import headerLayout from '@/components/layout/headerLayoutWxapp'

export default {
  components: {
    leftMeun,
    headRight,
    headerLayout
  },
  data() {
    return {
      urlPath: URL_PATH,
      data_list: [], //数据列表
      pushOpen: Constant.options_yesorno,
      optionsOpen: Constant.options_state_product,
      elementui_page_key: 0,
      pageCount: 0, // 所有页数
      pageMaxSize: LIST_PAGE_MAX_SIZE,
      currentPage: 1,
      screen_status: ''
    }
  },
  activated() {
    this.getList()
  },
  deactivated() {},
  created() {
    this.getList()
  },
  methods: {
    getList: function () {
      this.$api
        .integralProductList({
          token: localStorage.getItem('token'),
          page: this.currentPage,
          limit: this.pageMaxSize,
          where_status: this.screen_status
        })
        .then(({ data }) => {
          let current_page = Utils.listPage(data, this.currentPage)
          if (current_page) {
            this.currentPage = current_page
            this.getList()
          }
          this.pageCount = data.Data.pageCount
          this.data_list = data.Data.model
          this.data_list.forEach(info => {
            this.pushOpen.forEach(examin => {
              if (info.is_push == examin.en) {
                info.pushStr = examin.cn
              }
            })
            this.optionsOpen.forEach(examin => {
              if (info.status == examin.value) {
                info.resultStr = examin.text
              }
            })
            info.create_time = Utils.dateFormat(info.create_time * 1000)
          })
        })
        .catch(({ error }) => {})
    },
    currentChange(val) {
      this.elementui_page_key++
      this.currentPage = val
      this.getList()
    },
    // 过滤
    filterChange(filters) {
      this.screen_status = StrUtils.getStr4List1(filters.filterResult)
      this.getList()
    },
    cellStyle(row, column, rowIndex, columnIndex) {
      if (row.column.label === '库存总数' && row.row.stock <= 5) {
        return 'color:red'
      }
    },
    // 新建
    addInfo() {
      this.$router.push({
        path: '/wxapp/integral_product_add'
      })
    },
    // 编辑
    editInfo(row) {
      this.$router.push({
        path: '/wxapp/integral_product_add',
        query: {
          id: row.id
        }
      })
    },
    // 删除
    deleteInfo(row) {
      this.$confirm('是否删除此商品信息?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.$api
            .delIntegralProduct({
              token: localStorage.getItem('token'),
              product_id: row.id
            })
            .then(({ data }) => {
              this.getList()
            })
            .catch(({ error }) => {})
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="less" scoped>
.mainbody {
  overflow: hidden;
  background-color: #ffffff;
  border-radius: 5px;
  padding-bottom: 58px;
}
.mainbody .title {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.85);
  padding: 16px 32px;
}
.mainbody .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.mainbody .tableInfo {
  box-sizing: border-box;
  margin-left: 32px;
  margin-right: 32px;
}
.operateText {
  font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// src/components/integral/productList.vue